import dayjs from "dayjs";

const Footer = () => {
    return (
        <footer className="bg-gray-100 py-4">
            <div className="text-center">
                <div className="mt-3">
                    <p className="text-gray-500">Tenha a Fonoaudiologia na palma da sua mão.</p>
                    <p className="text-gray-500">Fonoaudiologia na Prática LTDA. Todos os direitos reservados. © {dayjs().year()}.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
